import { useAnalytics } from '@hooks/useAnalytics';

/**
 * AnalyticsTracker component that automatically tracks page views
 * when the route changes using react-ga4
 */
const AnalyticsTracker = (): null => {
    useAnalytics();
    return null;
};

export default AnalyticsTracker;
